import { gpioInputTemplate, gpioOutputTemplate, gpioSourceTemplate } from '@/store/bosc/mcu/GpioSource';
import { usartCodeTemplate, usartPinCodeTemplate } from '@/store/bosc/mcu/UsartTemplate';
import { spiCodeTemplate, spiPinCodeTemplate } from '@/store/bosc/mcu/SpiTemplate';
import { replaceMe } from './utils';
import {  IP_DISABLE, IP_ENABLE } from './constants';
import { writeUserChip, writeSourceFile } from './file';

/**
 * 生成代码
 * 
 * @param {*} state 
 * @returns 
 */
export async function generateCode({state}) {

    console.log(`generateCode()`, state)

    await writeUserChip(state);

    for (const ip of state.chip.ips) {
        console.log(`ip.mode=${ip.mode}, ip.name=${ip.name}`);
        if (ip.mode === IP_ENABLE || ip.mode !== IP_DISABLE) {
            switch (ip.name) {
                case 'GPIO':
                    gpioGenerate(state, ip);
                    break;
                case 'USART':
                    usartGenerate(state, ip);
                    break;
                case 'SPI':
                    spiGenerate(state, ip);
                    break;
                default:
                    console.error(`Unsupport ip name`, ip.name);
                    break;
            }
        }
    }
}

async function gpioGenerate(state, ipInstance) {

    if (ipInstance.pins.length === 0) {
        return;
    }

    // console.log('@', state);
    const snippets = [];
    for (const pin of ipInstance.pins) {
        const signal = pin.signal;

        if (signal === 'GPIO_Input') {
            const str = replaceMe(gpioInputTemplate, pin);
            snippets.push(str);
        } else if (signal === 'GPIO_Output') {
            const str = replaceMe(gpioOutputTemplate, pin);
            snippets.push(str);
        }
    }

    const pinsCode = snippets.join('\n');

    const content = replaceMe(gpioSourceTemplate, {pinsCode});

    console.log('GPIO', content)

    await writeSourceFile(state, 'gpio', content);
}

async function usartGenerate(state, ipInstance) {

    const code = replaceMe(usartCodeTemplate, ipInstance);

    
    const snippets = [];
    for (const pin of ipInstance.pins) {
        const str = replaceMe(usartPinCodeTemplate, pin);
        snippets.push(str);
    }

    const pinsCode = snippets.join('\n    ');

    const content = replaceMe(code, {pinsCode});

    await writeSourceFile(state, 'usart', content);
}

async function spiGenerate(state, ipInstance) {

    const code = replaceMe(spiCodeTemplate, ipInstance);

    
    const snippets = [];
    for (const pin of ipInstance.pins) {
        const str = replaceMe(spiPinCodeTemplate, pin);
        snippets.push(str);
    }

    const pinsCode = snippets.join('\n    ');

    const content = replaceMe(code, {pinsCode});

    // console.log(`spiGenerate`, content)

    await writeSourceFile(state, 'spi', content);
}